export const deliverySettings = {
	title: "Configure delivery and integrations",
	description: "Integrate with a delivery partner and centralize your management in Zig.",
	integrateButton: "New integration",
	tabs: {
		management: "Integration management",
		integrate: "Integrate delivery",
		configuration: "Settings",
	},
	integrate: {
		steps: {
			systemLabel: "Select integration system",
			authLabel: "Authenticate integration",
			syncMenuLabel: "Sync menu",
			systemAndAuth: {
				titleSystemIntegration: "Integration system",
				titleAuth: "Authenticate with partner system",
				descriptionIFood: "Paste your API key provided by IFood.",
				descriptionAuthRappi: "Paste your API key provided by Rappi.",
				labelSelect: "Select who you want to integrate with",
				labelInput: "Store ID",
				labelCNPJ: "Store CNPJ",
				errorCNPJRequired: "CNPJ is required",
				placeholderInputIFood: "Paste the code copied from iFood",
				placeholderInputRappi: "Paste the code copied from Rappi",
				placeholderInput: "Paste the code here",
				placeholderCNPJ: "Enter the CNPJ",
				submitButton: "Continue with integration",
				buttonAddMore: "Add another store",
				avisoTitle: "We need authorization to integrate with Rappi",
				avisoDescription:
					"Send a request to our support team and we will get in touch to follow up with the integration process.",
				iFoodDialog: {
					title: "We need authorization to integrate",
					description:
						"To continue with the integration with iFood, your confirmation is required. To do this, you must access the system and generate an API key. When you copy the iFood key, return to continue with the integration.",
					cancelButton: "Cancel integration",
					openButton: "Open iFood",
				},
			},
			syncMenu: {
				title: "Soon you will be able to import your menu!",
				descriptionIFood:
					"In a few weeks you will be able to import your menu from iFood and use it also in our system.",
				descriptionRappi:
					"In a few weeks you will be able to import your menu from Rappi and use it also in our system.",
				syncOffMenuButton: "Finish integration without menu",
				syncPending: {
					title: "Bring your menu to Zig",
					description:
						"Associate your menu from {{externalStoreType}} with the products registered on Zig and have a centralized management.",
					syncMenuButton: "Sync menu from {{externalStoreType}}",
					syncLate: "Sync later",
				},
				importPending: {
					title: "Bring your menu to Zig",
					description:
						"You can import your menu from {{externalStoreType}} and use it also in our system.",
					syncMenuButton: "Import menu from {{externalStoreType}}",
					completeWithoutMenu: "Finish integration without menu",
				},
			},
		},
	},
	management: {
		newMerchantTitle: "Add new store",
		newMerchantButton: "Add store",
		labelInput: "Store ID",
		integrationDescription: "API integration",
		integrationDescriptionWithDate: "API integration - {{date}}",
		removeIntegration: "Remove integration",
		saveChanges: "Save changes",
		backToImport: "Back to Import",
		syncMenu: "Continue Sync",
		merchants: "Stores",
		active: "Active",
		activeIntegration: "Activate integration",
		disableIntegration: "Deactivate integration",
		integrationSuccess: "Integration updated successfully",
		integrationError: "Error updating integration. Please try again.",
		awaitIntegration: "Waiting for integration",
		removeIntegrationModal: {
			button: "Remove integration",
			title: "Remove integration",
			description: "Are you sure you want to remove the integrations?",
			okText: "Confirm",
			cancelText: "Cancel",
		},
		emptyState: {
			title: "There's nothing here yet",
			description: "It looks like you don't have a delivery integrated yet.",
			button: "Integrate a Delivery",
		},
	},
	coalaConfig: {
		emptyState: {
			title: "There's nothing here yet",
			description: "It looks like you don't have a menu to configure.",
			button: "Integrate a Delivery",
		},
	},
};
